function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.707 2.293a1 1 0 10-1.414 1.414L16.934 9H1a1 1 0 000 2h15.934l-5.641 5.293a1 1 0 001.414 1.414l6.999-6.998.012-.013a.997.997 0 00-.01-1.403l-7-7z",
  fill: "#fff"
});
function SvgArrowRightExpanded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref);
}
export default __webpack_public_path__ + "fonts/arrow-right-expanded-794327c948cde3e1a25283bf040946bd.svg";
export { SvgArrowRightExpanded as ReactComponent };